exports.Feed = [
  {
    id: "id",
    name: "id",
    type: "text",
    value: "",
    label: "Id",
    key: "true",
    length: 12,
  },
  {
    id: "universalDescriptor",
    name: "universalDescriptor",
    type: "text",
    value: "",
    label: "Universal Descriptor",
    key: "true",
    length: 50,
  },
  {
    id: "nameLocalizedText",
    name: "nameLocalizedText",
    type: "text",
    value: "",
    label: "nameLocalizedText",
  },
  {
    id: "transactionDateDeterminationId",
    name: "transactionDateDeterminationId",
    type: "text",
    value: "",
    label: "Transaction Date Deterination",
  },
  {
    id: "type",
    name: "type",
    type: "text",
    value: "",
    label: "Type",
    length: 50,
  },
  {
    id: "sourceId",
    name: "sourceId",
    type: "text",
    value: "",
    label: "Source Id",
    length: 12,
  },
  {
    id: "validationProcedureId",
    name: "validationProcedureId",
    type: "text",
    value: "",
    label: "Validation Procedure Id",
    length: 12,
  },
  {
    id: "isSumSimilarItems",
    name: "isSumSimilarItems",
    type: "boolean",
    value: "",
    label: "Is Sum Similar Items",
  },
  {
    id: "isDuplicateOverride",
    name: "isDuplicateOverride",
    type: "boolean",
    value: "",
    label: "Is Duplicate Override",
  },
  {
    id: "dataFormatId",
    name: "dataFormatId",
    type: "number",
    value: "",
    label: "Data Format Id",
  },
  {
    id: "createdBy",
    name: "createdBy",
    type: "text",
    label: "Created By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "createdOn",
    name: "createdOn",
    type: "datetime",
    label: "Created On",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedBy",
    name: "modifiedBy",
    type: "text",
    label: "Modified By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedOn",
    name: "modifiedOn",
    type: "datetime",
    label: "ModifiedOn",
    displayonly: "true",
    value: " ",
  },
  {
    id: "nameResourceKey",
    name: "nameResourceKey",
    type: "text",
    value: "",
    label: "nameResourceKey",
    hide: "true",
    displayonly: "true",
  },
];
